{
  "title": "Power Word: Stun",
  "source": "Player's Handbook",
  "levelAndSchool": "8th-level enchantment",
  "level": 8,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "You speak a word of power that can overwhelm the mind of one creature you can see within range, leaving it dumbfounded. If the target has 150 hit points or fewer, it is stunned. Otherwise, the spell has no effect. The stunned target must make a Constitution saving throw at the end of each of its turns. On a successful save, this stunning effect ends."
  ],
  "spellLists": ["bard", "sorcerer", "warlock", "wizard"]
}
